export * from './MediaUiAPlayForwardIcon';
export * from './MediaUiAPlayForwardIcon16Light';
export * from './MediaUiAPlayForwardIcon16Regular';
export * from './MediaUiAPlayForwardIcon16Solid';
export * from './MediaUiAPlayForwardIcon20Light';
export * from './MediaUiAPlayForwardIcon20Regular';
export * from './MediaUiAPlayForwardIcon20Solid';
export * from './MediaUiAPlayForwardIcon24Regular';
export * from './MediaUiAPlayForwardIcon24Solid';
export * from './MediaUiAPlayForwardIcon32Regular';
export * from './MediaUiAPlayForwardIcon64Regular';
